
import React from 'react';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import BobetteSection from '../components/BobetteSection';
import VideoSection from '../components/VideoSection';
import HowItWorksSection from '../components/HowItWorksSection';
import TestimonialSection from '../components/TestimonialSection';
import CallToAction from '../components/CallToAction';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import FlowBackground from '../components/FlowBackground';

const Index = () => {
  return (
    <div className="min-h-screen flex flex-col relative">
      {/* Add the FlowBackground component here */}
      <FlowBackground />
      
      <Navbar />
      <main className="flex-grow">
        <HeroSection />
        
        <VideoSection 
          title="Ontdek de kracht van AI voor jouw bedrijf" 
          description="Wij geloven dat kunstmatige intelligentie voor iedereen toegankelijk moet zijn. In deze video leggen we uit hoe Noord AI jouw bedrijf kan helpen groeien door slimme AI-toepassingen."
          videoId="44UUzUyvi0M"
        />
        
        <ServicesSection />
        
        <BobetteSection />
        
        <HowItWorksSection />
        
        <VideoSection 
          title="Praktijkvoorbeelden van AI in het MKB" 
          description="Benieuwd hoe andere ondernemers AI gebruiken? In deze video delen we een aantal praktijkvoorbeelden van bedrijven in Noord-Nederland die met onze hulp AI hebben geïmplementeerd."
        />
        
        <TestimonialSection />
        
        <CallToAction />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
